export abstract class WorldActivatorService {
    welcomeDialogDisplayed: boolean;
}

export function WorldActivatorServiceFactory($injector: angular.auto.IInjectorService) {
    return $injector.get('WorldActivator');
}

export const WorldActivatorServiceProvider = {
    provide: WorldActivatorService,
    useFactory: WorldActivatorServiceFactory,
    deps: ['$injector']
};
